import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { MetaReducer, StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from '../../environments/environment';
import { hydrationMetaReducer, reducer } from './app-store.reducer';
import { AppStoreEffects } from './app-store.effects';

const metaReducers: Array<MetaReducer> = [hydrationMetaReducer];

@NgModule({
  imports: [
    StoreModule.forRoot({ app: reducer }, { metaReducers }),
    EffectsModule.forRoot([AppStoreEffects]),
    !environment.production ? StoreDevtoolsModule.instrument() : [],
  ],
})
export class AppStoreModule {}
